<template>
  <div class="mobileProductListPage" @scroll="listbingsrcoll">
    <div class="mobileProductListPage-content">
      <!--            <div class=" clearfix" :class="['mobileProductListPage-top', window_height<(scroll_Value+65)?'fix-menu':'']">-->
      <!--                <div class="mobileProductListPage-top-left" @click="changeProductType('1')"><span :class="{'mobileProductListTypeActive':mobileProductListType=='1'}">全部产品</span></div>-->
      <!--                <div class="mobileProductListPage-top-right" @click="changeProductType('2')"><span :class="{'mobileProductListTypeActive':mobileProductListType=='2'}">场景方案</span></div>-->
      <!--            </div>-->
      <!-- <div
        class="mobileProductListPage-main1 clearfix"
        v-if="mobileProductListType == 1"
      >
        <div
          class="mobileProductListPage-main-content clearfix"
          v-for="(item, index) in product_list"
          :key="index + '1'"
        >
          <div class="mobileProductListPage-main-content-title">
            {{ item.label }}
          </div>
          <div
            class="mobileProductListPage-main-content-childList clearfix"
            v-for="(child, index) in item.children"
            :key="index + 'c1'"
            @click="chose_child(child.type, child.value)"
          >
            <div class="mobileProductListPage-main-content-childList-img">
              <img :src="child.img" alt="child.label" style="width: 60%" />
            </div>
            <div class="mobileProductListPage-main-content-childList-title">
              {{ child.label }}
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="mobileProductListPage-main2"
        v-if="mobileProductListType == 2"
      >
        <!-- <div class="mobileProductListPage-main-scene">
                    <div class="mobileProductListPage-main-scene-part" v-for="item in prolist" :key="item.uuid"  @click="goto_sceneDetail(item)">
                        <img :src="item.websiteIndustryPicEntityList?item.websiteIndustryPicEntityList[0].requestPath:''" alt="行业图" style="width: 100%;">
                        <div class="product-title">
                            <div>{{item.title}}</div>
                            <div>{{item.websiteIndustryPicEntityList?item.websiteIndustryPicEntityList[1].content:''}}</div>
                        </div>
                    </div>
                </div> -->
        <!-- 移动端产品方案 -->
        <div class="row" style="border-top: 1px solid #eaeaea">
          <div
            style="width: 100%; margin-bottom: 20px"
            v-for="item in product_listData"
            :key="item.uuid"
          >
            <div class="mobileProductListPage-main2-title">
              {{ item.productName }}
            </div>
            <div
              class="mobileProductListPage-main2List"
              v-for="child in item.childProductList"
              :key="child.uuid"
              @click="go_product_info(child.webModel, child.uuid)"
            >
              <div class="mobileProductListPage-main2Img">
                <img
                  :src="child.productUrl"
                  :alt="child.productName"
                  style="width: 60%"
                />
              </div>
              <div class="mobileProductListPage-main-content-childList-title">
                {{ child.productName }}
              </div>
            </div>

            <!-- <span v-if="item.isnew" class="is-New"> NEW </span> -->
          </div>
        </div>
      </div>
      <home-foot ref="homefoot"></home-foot>
    </div>
  </div>
</template>
<script>
import HomeFoot from "@/components/HomeFoot";
import { Loading } from "element-ui";

export default {
  name: "mobileProductList",
  components: {
    HomeFoot,
  },
  data() {
    return {
      window_height: 100,
      mobileProductListType: "1",
      scroll_Value: "0",
      prolist: [],
      product_listData: [],
      chose_product: "",
      show_hoverMenu: 0,
      hoverStatus: false,
      // 进度提示
      saveLoading: false,
      windowSIZE: {
        screenWidth: document.documentElement.clientWidth,
        screenHeight: document.documentElement.clientHeight,
      },
    };
  },
  activated() {
    this.initTreeByWebsite();
  },
  created() {
    this.initTreeByWebsite();
  },

  methods: {
    listbingsrcoll(e) {
      // this.scroll_Value = e.srcElement.scrollTop;
    },
    //获取移动端数据
    initTreeByWebsite() {
      this.$nextTick(() => {
        this.$refs.homefoot.homefoot = false;
      });
      if (true) {
        this.saveLoading = Loading.service({
          lock: true,
          background: "rgba(190, 190, 190, 0.2)",
        });
        this.saveLoading.text = "请稍后。。。";
        axios
          .get(
            `${window.$server_config.VUE_APP_WEBSITE_API}outer/product/initTree?isEn=`+ '0'
          )
          .then((response) => {
            // 关闭进度提示
            this.saveLoading.close();
            //console.log(response)
            var res = response.data;
            if (res.code === 200) {
              this.$refs.homefoot.homefoot = true;
              this.product_listData = res.data;
              console.log(this.product_listData,"111")
            } else {
              this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
            }
          }).catch((error)=>{
            this.saveLoading.close();
          })
      }
    },
    changeProductType(type) {
      this.mobileProductListType = type;
    },
    chose_child(type, value) {
      this.$router.push(`/product/${type}/${value}`);
    },
    goto_sceneDetail(item) {
      //去行业方案详情页
      this.$router.push(`/mobileScene/${item}`);
    },
    //详情跳转
    go_product_info(type, id) {
      this.show_hoverMenu = "0";
      this.hoverStatus = false;
      window.onresize = function () {
      // 定义窗口大小变更通知事件
      this.windowSIZE.screenWidth = document.documentElement.clientWidth; //窗口宽度
      this.windowSIZE.screenHeight = document.documentElement.clientHeight; //窗口高度
    };
      // console.log(this.windowSIZE.screenWidth, this.windowSIZE.screenHeight,"xxx");
      let widths=this.windowSIZE.screenWidth
      if(widths<990){
        this.$router.push(`/movingEnd/${id}`);
      }else{
      this.$router.push(`/productinfo${type}/${id}`);
      }

    },
    getPro() {
      let isEn = ('1' == sessionStorage.getItem("isEn") ? '1':'0');
      //获取行业方案
      axios
        .get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/industry/list?isEn=`+isEn)
        .then((response) => {
          var res = response.data;
          if (res.code === 200) {
            var prolist = res.data;
            if (prolist.length > 5) {
              //大于5个后只显示前5个
              this.prolist = prolist.slice(0, 5);
            } else {
              this.prolist = prolist;
            }
          } else {
            this.$message.error(res.msg ? res.msg : "请求有误，请稍后重试");
          }
        });
    },
  },
  mounted() {
    this.mobileProductListType = this.$route.params.type;
    this.getPro();
  },
};
</script>
<style scoped>
.mobileProductListPage {
  height: 100%;
  padding-top: 50px;
  overflow: auto;
}
.mobileProductListPage-content {
  width: 100%;
}
.mobileProductListPage-top {
  width: 100%;
  height: 50px;
  z-index: 100;
  border-bottom: 0.5px solid #dfdfdf;
}
.mobileProductListPage-top-left {
  width: 100%;
  float: left;
  text-align: center;
  line-height: 50px;
}
.mobileProductListPage-top-right {
  width: 50%;
  float: right;
  text-align: center;
  line-height: 50px;
}
.mobileProductListPage-top-left span,
.mobileProductListPage-top-right span {
  display: inline-block;
  padding: 0 15px;
  line-height: 46px;
}
.mobileProductListTypeActive {
  border-bottom: 2px solid #3bbde7;
}
.mobileProductListPage-main1 {
  width: 100%;
  padding: 20px 5% 20px;
}
.mobileProductListPage-main2 {
  width: 100%;
}

.mobileProductListPage-main2 .row {
  height: 100%;
  background: #fff;
  padding: 20px 5%;
}
.mobileProductListPage-main2-title {
  width: 100%;
  height: 30px;
  font-size: 18px;
  font-weight: 600;
  color: #2c2c2c;
}
.mobileProductListPage-main2List {
  width: 33.3333%;
  height: 120px;
  /* max-height: 250px; */
  float: left;
  text-align: center;
  margin: 10px auto 10px;
}
.mobileProductListPage-main2Img {
  width: 100%;
  margin-bottom: 5px;
}
.mobileProductListPage-main-content {
  width: 100%;
  margin-bottom: 20px;
}
.mobileProductListPage-main-content-title {
  width: 100%;
  height: 30px;
  font-size: 18px;
  font-weight: 600;
  color: #2c2c2c;
}
.mobileProductListPage-main-content-childList {
  width: 33.3333%;
  height: 120px;
  /* max-height: 250px; */
  float: left;
  text-align: center;
  margin: 10px auto 10px;
}
.mobileProductListPage-main-content-childList-img {
  width: 100%;
  margin-bottom: 5px;
}
.mobileProductListPage-main-content-childList-title {
  width: 75%;
  margin: 0 auto;
  font-size: 14px;
  color: #2c2c2c;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.mobileProductListPage-main-scene {
  width: 100%;
}
.mobileProductListPage-main-scene-part {
  width: 100%;
  position: relative;
}
.product-title {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  width: 90%;
  margin: 0 auto;
}
.product-title > div:nth-child(1) {
  font-size: 20px;
  line-height: 20px;
  margin-bottom: 14px;
  font-weight: 600;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.product-title > div:nth-child(2) {
  font-size: 14px;
  line-height: 14px;
  display: inline-block;
  text-align: justify;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-inline-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
@media only screen and (min-width: 620px) and (max-width: 1025px) {
  .mobileProductListPage-main2List {
    height: auto;
  }
  .mobileProductListPage-main-content-childList-title {
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobileProductList.vue